(() => {
  const $ = id => document.getElementById(id);
  const money = cents => new Intl.NumberFormat('en-IN', {
    style: 'currency',
    currency: 'INR',
    maximumFractionDigits: 0
  }).format((Number(cents) || 0) / 100);

  const toast = message => {
    const el = $('toast');
    if (!el) return;
    el.textContent = message;
    el.classList.add('up');
    clearTimeout(el._t);
    el._t = setTimeout(() => el.classList.remove('up'), 1600);
  };

  function openThemeCart(startCheckout = false) {
    document.querySelector('[data-cart-sidebar]')?.click();
    if (!startCheckout) return;
    let tries = 0;
    const timer = setInterval(() => {
      tries += 1;
      const button = document.querySelector(
        '#halo-cart-sidebar .gokwik-checkout button:not([disabled]), .gokwik-checkout button:not([disabled])'
      );
      if (button) {
        clearInterval(timer);
        button.click();
      } else if (tries > 30) {
        clearInterval(timer);
      }
    }, 150);
  }

  async function addItems(items) {
    const hasProperties = items.some(item => item && item.properties && Object.keys(item.properties).length);
    let payloadItems;

    if (hasProperties) {
      payloadItems = items
        .filter(item => item && item.id)
        .map(item => ({
          id: Number(item.id),
          quantity: Number(item.quantity || 1),
          ...(item.properties ? {properties:item.properties} : {})
        }));
    } else {
      const grouped = new Map();
      items.forEach(item => {
        const id = String(item.id);
        grouped.set(id, (grouped.get(id) || 0) + Number(item.quantity || 1));
      });
      payloadItems = [...grouped].map(([id, quantity]) => ({id: Number(id), quantity}));
    }

    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: {'Content-Type': 'application/json', Accept: 'application/json'},
      body: JSON.stringify({items: payloadItems})
    });

    if (!response.ok) {
      let error = {};
      try { error = await response.json(); } catch (_) {}
      throw new Error(error.description || error.message || 'Unable to add products.');
    }

    const cart = await fetch('/cart.js').then(result => result.json());
    if ($('cartN')) $('cartN').textContent = `Cart (${cart.item_count})`;
    if (window.halo && typeof window.halo.updateSidebarCart === 'function') {
      window.halo.updateSidebarCart(cart);
    }
  }

  function createBundleId() {
    return `ob_${Date.now()}_${Math.random().toString(36).slice(2, 9)}`;
  }

  function createBundleProperties({source, type, pricingRule, quantity, name}) {
    return {
      _ob_bundle_id: createBundleId(),
      _ob_bundle_source: String(source || 'combos_page'),
      _ob_bundle_type: String(type || 'unknown'),
      _ob_pricing_rule: String(pricingRule || type || 'unknown'),
      _ob_bundle_qty: String(Number(quantity) || 1),
      _ob_bundle_name: String(name || 'Ombre Bliss Combo'),
      _ob_bundle_version: '1'
    };
  }

  const AUTO_COMBOS = [
    {type:'Layering',name:'Rum & Cream',for:'96% match · our best-selling pair',
      items:[['Smoky Rum','couture25'],['Vanilla Kiss','couture25']],
      d:'Smoky Rum lays down tobacco and rum. Vanilla Kiss pours cream over the top. The smoke turns into dessert and lasts longer than either scent alone.',
      how:'2 sprays Smoky Rum, wait 30 seconds, then 1 spray Vanilla Kiss.'},
    {type:'Layering',name:'Oud Rose',for:'95% match · the oldest pairing there is',
      items:[['Nawab Oud','couture25'],['Amber Rose','couture25']],
      d:'Nawab Oud gives the depth and Amber Rose gives the bloom. Their amber base lets them stack instead of fight.',
      how:'2 sprays Nawab Oud, wait 30 seconds, then 1 spray Amber Rose.'},
    {type:'Layering',name:"The Nawab's Jacket",for:'94% match · for cold nights only',
      items:[['Classic Leather','couture25'],['Nawab Oud','couture25']],
      d:'Leather underneath, agarwood on top. Two heavyweights that share an amber base.',
      how:'2 sprays Classic Leather, wait 30 seconds, then 1 spray Nawab Oud.'},
    {type:'Layering',name:'The Cigar Lounge',for:'93% match · tobacco made softer',
      items:[['Royale Tobacco','couture25'],['Vanilla Kiss','couture25']],
      d:'Cinnamon and pipe tobacco softened with brown sugar and rum.',
      how:'2 sprays Royale Tobacco, wait 30 seconds, then 1 spray Vanilla Kiss.'},
    {type:'Layering',name:'Halwa',for:'92% match · sounds mad, works',
      items:[['Royale Tobacco','couture25'],['Pistachio Pop','couture25']],
      d:'Spiced tobacco under pistachio gelato. It smells like a great mithai shop in winter.',
      how:'2 sprays Royale Tobacco, wait 30 seconds, then 1 spray Pistachio Pop.'},
    {type:'Layering',name:'Weekday Armour',for:'90% match · office-safe leather',
      items:[['Classic Leather','couture25'],['Ombre Blu','couture25']],
      d:'Ombre Blu opens Classic Leather with citrus and makes it easier to wear at a desk.',
      how:'2 sprays Classic Leather, wait 30 seconds, then 1 spray Ombre Blu.'},

    {type:'Personality',name:'The Quiet Power',for:'For people who never raise their voice',
      items:[['Classic Leather','couture100'],['Honour','classic100'],['Ombre Blu','couture100']],
      d:'Nothing here shouts. This is for the person who arrives early and is remembered anyway.'},
    {type:'Personality',name:'The Showstopper',for:'For people who are never underdressed',
      items:[['Nawab Oud','couture100'],['Angel','couture100'],['Royale Tobacco','couture100']],
      d:'Our three loudest scents in one box — oud, cocoa and tobacco.'},
    {type:'Personality',name:'The Sweet Tooth',for:'For the ones people hug longer',
      items:[['Vanilla Kiss','couture100'],['Pistachio Pop','couture100'],['Lush Candy','couture100']],
      d:'Three gourmands that make people lean in and ask what you are wearing.'},
    {type:'Personality',name:'The Minimalist',for:'For people who own five shirts',
      items:[['Ombre Blu','couture100'],['Pierce','classic100']],
      d:'Clean, sharp and uncomplicated — a two-bottle wardrobe.'},
    {type:'Personality',name:'The Rebel',for:'For people who like being misread',
      items:[['Vicious','classic100'],['Yakuza','classic100']],
      d:'Peppery, woody and a little unfriendly. That is the point.'},
    {type:'Personality',name:'The Romantic',for:'Soft outside, absolutely not inside',
      items:[['Amber Rose','couture100'],['Luna','classic100']],
      d:'Rose with an edge and vanilla with a hush.'},

    {type:'Mood',name:'Warm & Wrapped',for:'For cold evenings indoors',
      items:[['Vanilla Kiss','couture100'],['Royale Tobacco','couture100'],['Angel','couture100']],
      d:'Sweet, spiced and slow — three scents that behave like a blanket.'},
    {type:'Mood',name:'Bright & Awake',for:'For 7am and Indian summers',
      items:[['Ombre Blu','couture100'],['Marino','classic100']],
      d:'Citrus, sea air and a clean spine for hot days.'},
    {type:'Mood',name:'Dark & Deep',for:'For after 9pm',
      items:[['Nawab Oud','couture100'],['Vicious','classic100'],['Classic Leather','couture100']],
      d:'Resin, pepper and leather. Nothing here is meant for daylight.'},
    {type:'Mood',name:'Soft Focus',for:'For slow Sundays',
      items:[['Luna','classic100'],['The Bouquet','classic100']],
      d:'Gentle florals and warm vanilla that sit close to the skin.'},

    {type:'Occasion',name:'Wedding Season',for:'Sangeet, reception, the lot',
      items:[['Nawab Oud','couture100'],['Royale Tobacco','couture100'],['Amber Rose','couture100']],
      d:'Three scents built for rooms full of people, heavy fabric and long nights.'},
    {type:'Occasion',name:'Office to Evening',for:'One day, two versions of you',
      items:[['Ombre Blu','couture100'],['Classic Leather','couture100']],
      d:'Ombre Blu at your desk, Classic Leather after seven.'},
    {type:'Occasion',name:'Date Night',for:'Close-range scents',
      items:[['Vanilla Kiss','couture100'],['Amber Rose','couture100']],
      d:'Both are built for a metre of distance, not a room.'},
    {type:'Occasion',name:'The Everyday Three',for:'New to perfume? Start here',
      items:[['Marino','classic100'],['Honour','classic100'],['Pierce','classic100']],
      d:'Three easy, wearable Classic eau de parfums.'},
    {type:'Occasion',name:'Festive Nights',for:'Diwali, Eid, everything lit',
      items:[['Nawab Oud','couture100'],['Angel','couture100'],['Luna','classic100']],
      d:'Oud, cocoa and vanilla that hold their own against incense and a full room.'},
    {type:'Occasion',name:'The Travel Three',for:'Cabin-bag sized',
      items:[['Smoky Rum','couture25'],['Ombre Blu','couture25'],['Vanilla Kiss','couture25']],
      d:'Three 25ml Couture bottles — smoky, fresh and sweet — for any trip.'},
    {type:'Occasion',name:'The Discovery Five',for:"Can't decide? Try five",
      items:[['Smoky Rum','couture25'],['Classic Leather','couture25'],['Nawab Oud','couture25'],['Ombre Blu','couture25'],['Vanilla Kiss','couture25']],
      d:'Five 25ml Couture scents to help you find your signature.'}
  ];

  function init() {
    const dataEl = document.querySelector('[id^="ObExactCombosData-"]');
    if (!dataEl || dataEl.dataset.initialised) return;

    let data;
    try { data = JSON.parse(dataEl.textContent); } catch (_) { return; }
    dataEl.dataset.initialised = '1';

    const parseGlobalPrices = value => String(value || '')
      .split(',')
      .map(value => Math.round(Number(value.trim()) * 100))
      .filter(value => Number.isFinite(value) && value > 0);

    const globalPricing = data.globalPricing || {};
    const useGlobalPricing = globalPricing.enabled !== false;
    const globalPriceLists = {
      couture100: parseGlobalPrices(globalPricing.couture100),
      couture25: parseGlobalPrices(globalPricing.couture25),
      classic100: parseGlobalPrices(globalPricing.classic100)
    };
    const giftSetPrice = Number(globalPricing.giftSet) || 69900;
    const lines = data.lines || [];
    const bundleCheckout = data.bundleCheckout || {};

    function bundleVariantFor(key, quantity) {
      const bundle = bundleCheckout[key];
      if (!bundleCheckout.enabled || !bundle || !Array.isArray(bundle.variants)) return null;
      const q = Number(quantity) || 1;
      const byTitle = bundle.variants.find(variant => {
        const title = String(variant.title || '').toLowerCase();
        return new RegExp(`(^|\\D)${q}(\\D|$)`).test(title) && variant.available !== false;
      });
      return byTitle || bundle.variants.filter(variant => variant.available !== false)[q - 1] || null;
    }

    function checkoutKeyFor(keys) {
      const clean = keys.filter(Boolean);
      const hasClassic = clean.includes('classic100');
      const hasCouture = clean.some(key => key === 'couture100' || key === 'couture25');
      if (hasClassic && hasCouture) return 'couture100';
      if (clean.includes('couture100')) return 'couture100';
      if (clean.includes('couture25')) return 'couture25';
      return 'classic100';
    }

    async function addPricedOrComponents(keys, ids, titles, label, source = 'combos_page_ready_made') {
      const key = checkoutKeyFor(keys);
      const cleanKeys = keys.filter(Boolean);
      const hasClassic = cleanKeys.includes('classic100');
      const hasCouture = cleanKeys.some(item => item === 'couture100' || item === 'couture25');
      const markerType = hasClassic && hasCouture ? 'mixed100' : key;
      const bundleProperties = createBundleProperties({
        source,
        type: markerType,
        pricingRule: key,
        quantity: ids.length,
        name: label || 'Perfume box'
      });
      const bundleVariant = bundleVariantFor(key, ids.length);

      if (bundleVariant) {
        await addItems([{
          id: bundleVariant.id,
          quantity: 1,
          properties: {
            ...bundleProperties,
            'Combo': label || 'Perfume box',
            'Selected scents': titles.join(', ')
          }
        }]);
        return true;
      }

      await addItems(ids.map(id => ({
        id,
        quantity: 1,
        properties: {...bundleProperties}
      })));
      return false;
    }

    if (useGlobalPricing) {
      lines.forEach(lineItem => {
        const list = globalPriceLists[lineItem.key] || [];
        if (list.length) {
          lineItem.tiers = list.map((fixedTotal, index) => ({
            quantity: index + 1,
            fixedTotal,
            label: 'Global offer price'
          }));
        }
      });
    }

    let line = lines[0] || null;
    const selected = [];

    const tierFor = (lineItem, quantity) => [...(lineItem?.tiers || [])]
      .sort((a, b) => a.quantity - b.quantity)
      .reverse()
      .find(tier => quantity >= tier.quantity) || null;

    const maxForLine = lineItem => Math.max(
      1,
      ...(lineItem?.tiers || []).map(tier => Number(tier.quantity) || 0)
    );

    const regularItems = () => selected.filter(item => !item.isGift);
    const giftItems = () => selected.filter(item => item.isGift);

    const displayRegularTotal = (lineItem, items) => {
      if (!items.length) return 0;
      const tier = tierFor(lineItem, items.length);
      return tier && Number(tier.fixedTotal) > 0
        ? Number(tier.fixedTotal)
        : items.reduce((sum, item) => sum + Number(item.price || 0), 0);
    };

    const displayTotal = () =>
      displayRegularTotal(line, regularItems()) + giftItems().length * giftSetPrice;

    const compareTotal = () => selected.reduce(
      (sum, item) => sum + Math.max(Number(item.compare || 0), Number(item.price || 0)),
      0
    );

    function renderLines() {
      const el = $('lines');
      if (!el) return;
      el.innerHTML = lines.map(item => {
        const gifts = item.products.filter(product => product.isGift).length;
        const scents = item.products.length - gifts;
        const countText = gifts ? `${scents} scents + ${gifts} gift sets` : `${scents} scents`;
        return `
          <button class="lineopt ${line && item.id === line.id ? 'on' : ''}" type="button" data-line="${item.id}">
            <div class="lo-t">${item.label}</div>
            <div class="lo-s">${item.subtitle}</div>
            <div class="lo-p">${countText}</div>
          </button>
        `;
      }).join('');

      el.querySelectorAll('[data-line]').forEach(button => {
        button.addEventListener('click', () => {
          line = lines.find(item => item.id === button.dataset.line) || null;
          selected.length = 0;
          renderAll();
        });
      });
    }

    function jumpTo(quantity) {
      if (!line) return;
      const pool = line.products.filter(product => !product.isGift);
      const wanted = Math.min(Number(quantity) || 0, maxForLine(line));
      while (regularItems().length > wanted) {
        const index = selected.findLastIndex ? selected.findLastIndex(item => !item.isGift) : (() => {
          for (let i = selected.length - 1; i >= 0; i -= 1) if (!selected[i].isGift) return i;
          return -1;
        })();
        if (index >= 0) selected.splice(index, 1);
      }
      while (regularItems().length < wanted && pool.length) {
        selected.push({...pool[regularItems().length % pool.length]});
      }
      renderAll();
    }

    function renderLadder() {
      if (!line) return;
      const quantity = regularItems().length;
      const tiers = [...(line.tiers || [])].sort((a, b) => a.quantity - b.quantity);
      const rungs = $('lrRungs');
      if (!rungs) return;

      rungs.innerHTML = tiers.map(tier => `
        <button class="lr-rung ${quantity >= tier.quantity ? 'reach' : ''} ${quantity === tier.quantity ? 'now' : ''}"
          type="button" data-q="${tier.quantity}">
          <span class="flag">Current</span>
          <span class="lrq">${tier.quantity}</span>
          <span class="lro">${tier.fixedTotal > 0 ? `${money(Math.round(tier.fixedTotal / tier.quantity))} each` : tier.label || 'Live price'}</span>
          <span class="lrsave">${tier.fixedTotal > 0 ? money(tier.fixedTotal) : ''}</span>
        </button>
      `).join('');

      rungs.querySelectorAll('[data-q]').forEach(button => {
        button.addEventListener('click', () => jumpTo(button.dataset.q));
      });

      const max = Math.max(1, ...tiers.map(tier => tier.quantity));
      if ($('sbProg')) $('sbProg').style.width = `${Math.min(100, quantity / max * 100)}%`;
      const current = tierFor(line, quantity);

      if ($('sbS')) {
        $('sbS').innerHTML = current && current.fixedTotal > 0
          ? `<b>${money(current.fixedTotal)}</b> box total`
          : 'Add bottles to see your quantity price';
      }

      if ($('sbTip')) {
        if (!quantity) {
          $('sbTip').textContent = 'Tap a quantity above or add a scent below.';
        } else if (quantity < max) {
          const next = tierFor(line, quantity + 1);
          const extra = next ? Number(next.fixedTotal) - displayRegularTotal(line, regularItems()) : 0;
          $('sbTip').textContent = next && extra > 0
            ? `Add one more bottle for ${money(extra)}.`
            : `${quantity} selected · add more to unlock the next quantity price.`;
        } else {
          $('sbTip').textContent = `Maximum quantity price reached for ${line.label}.`;
        }
      }
    }

    function renderProducts() {
      if (!line || !$('scents')) return;
      $('scentsHead').textContent = line.label;

      $('scents').innerHTML = line.products.map(product => {
        const count = selected.filter(item => String(item.variantId) === String(product.variantId)).length;
        const shownPrice = product.isGift ? giftSetPrice : product.price;
        return `
          <article class="sc ${count ? 'picked' : ''}">
            <div class="sc-media">
              ${product.image
                ? `<img src="${product.image}" alt="${product.title}" loading="lazy">`
                : `<span class="sc-bot"><i style="background:${product.colour}"></i></span>`}
            </div>
            <div class="sc-i">
              <div class="sc-n">${product.title}</div>
              <div class="sc-f">${product.family || ''}${product.family ? ' · ' : ''}${money(shownPrice)}</div>
            </div>
            ${count
              ? `<div class="sc-qty">
                  <button type="button" data-minus="${product.variantId}" aria-label="Remove ${product.title}">−</button>
                  <span class="n">${count}</span>
                  <button type="button" data-plus="${product.variantId}" aria-label="Add ${product.title}">+</button>
                </div>`
              : `<button class="sc-add" type="button" data-plus="${product.variantId}">Add</button>`}
          </article>
        `;
      }).join('');

      $('scents').querySelectorAll('[data-plus]').forEach(button => {
        button.addEventListener('click', () => {
          const product = line.products.find(item => String(item.variantId) === String(button.dataset.plus));
          if (!product) return;
          if (!product.isGift && regularItems().length >= maxForLine(line)) {
            toast(`${line.label}: maximum ${maxForLine(line)} bottles.`);
            return;
          }
          selected.push({...product});
          toast(data.labels.added);
          renderAll();
        });
      });

      $('scents').querySelectorAll('[data-minus]').forEach(button => {
        button.addEventListener('click', () => {
          const index = selected.findIndex(item => String(item.variantId) === String(button.dataset.minus));
          if (index >= 0) selected.splice(index, 1);
          renderAll();
        });
      });
    }

    function renderSummary() {
      const summary = $('summary');
      if (!summary) return;
      const total = displayTotal();
      const compare = compareTotal();
      const quantity = regularItems().length;
      const tier = tierFor(line, quantity);

      if (!selected.length) {
        summary.innerHTML = `
          <div class="sum-h"><span class="sh-t">Your box</span><span class="sh-c">0 selected</span></div>
          <div class="sum-empty">${data.labels.empty}<br>Add any scent from the list.</div>`;
        return;
      }

      summary.innerHTML = `
        <div class="sum-h"><span class="sh-t">Your box</span><span class="sh-c">${selected.length} selected</span></div>
        <div class="sum-shelf">
          ${selected.map((item, index) => `
            <button class="sum-b" type="button" data-remove="${index}" title="Remove ${item.title}">
              ${item.image ? `<img src="${item.image}" alt="">` : `<i style="background:${item.colour}"></i>`}
            </button>`).join('')}
        </div>
        ${selected.map(item => `
          <div class="sum-line ${item.isGift ? 'gift' : ''}">
            <span>${item.title}</span>
            <span class="sl-r">${item.isGift ? money(giftSetPrice) : 'Included'}</span>
          </div>`).join('')}
        ${tier && tier.fixedTotal > 0 ? `<div class="sum-nudge">${quantity} ladder bottle${quantity === 1 ? '' : 's'}: <b>${money(tier.fixedTotal)}</b></div>` : ''}
        <div class="sum-total"><span class="st-l">Box total</span><span class="st-r">
          ${compare > total ? `<span class="was">${money(compare)}</span>` : ''}
          <span class="amt">${money(total)}</span>
        </span></div>
        <button class="sum-cta" type="button" id="sumAdd">Add box to cart</button>
        <button class="sum-clear" type="button" id="sumClear">Clear box</button>
      `;

      summary.querySelectorAll('[data-remove]').forEach(button => {
        button.addEventListener('click', () => {
          selected.splice(Number(button.dataset.remove), 1);
          renderAll();
        });
      });
      $('sumClear')?.addEventListener('click', () => { selected.length = 0; renderAll(); });
      $('sumAdd')?.addEventListener('click', () => submit(false));
    }

    function renderExplainer() {
      const el = $('ladders');
      if (!el) return;
      el.innerHTML = lines.map(item => `
        <article class="ladder-card">
          <div class="ladder-title">${item.label}</div>
          <div class="ladder-grid">
            ${[...(item.tiers || [])].sort((a, b) => a.quantity - b.quantity).map(tier => `
              <span><b>${tier.quantity}</b>${tier.fixedTotal > 0 ? money(tier.fixedTotal) : tier.label || 'Live price'}</span>
            `).join('')}
          </div>
          <div class="ladder-note">Controlled globally from Theme settings → OB Global Pricing.</div>
        </article>`).join('');
    }

    function renderBoxbar() {
      const bar = $('boxbar');
      if (!bar) return;
      bar.classList.toggle('on', selected.length > 0);
      bar.setAttribute('aria-hidden', selected.length ? 'false' : 'true');

      if ($('bbShelf')) {
        $('bbShelf').innerHTML = selected.slice(-8).map((item, index) => `
          <button class="bb-b" data-remove-bar="${index}" type="button">
            ${item.image ? `<img src="${item.image}" alt="">` : `<i style="background:${item.colour}"></i>`}
          </button>`).join('');
      }
      if ($('bbT')) $('bbT').textContent = selected.length ? `${selected.length} ${data.labels.selected}` : data.labels.empty;
      if ($('bbS2')) $('bbS2').textContent = line ? line.label : '';
      if ($('bbAmt')) $('bbAmt').textContent = money(displayTotal());
      const compare = compareTotal();
      if ($('bbWas')) $('bbWas').textContent = compare > displayTotal() ? money(compare) : '';

      $('bbShelf')?.querySelectorAll('[data-remove-bar]').forEach(button => {
        button.addEventListener('click', () => {
          selected.splice(Number(button.dataset.removeBar), 1);
          renderAll();
        });
      });
    }

    const normalize = value => String(value || '')
      .toLowerCase()
      .replace(/&/g, 'and')
      .replace(/[^a-z0-9]+/g, ' ')
      .trim();

    function lineByKey(key) {
      return lines.find(item => item.key === key);
    }

    function findProduct(title, key) {
      const target = normalize(title);
      const matchingLine = lineByKey(key);
      if (!matchingLine) return null;
      return matchingLine.products.find(product => normalize(product.title) === target)
        || matchingLine.products.find(product => normalize(product.title).includes(target) || target.includes(normalize(product.title)));
    }

    function resolvedCombo(combo) {
      const expected = combo.items.length;
      const items = combo.items.map(([title, key]) => {
        const product = findProduct(title, key);
        return product ? {...product, lineKey:key} : null;
      }).filter(Boolean);
      return {...combo, items, expected};
    }

    function comboTotals(items) {
      const hasClassic = items.some(item => item.lineKey === 'classic100');
      const hasCouture = items.some(item =>
        item.lineKey === 'couture100' || item.lineKey === 'couture25'
      );

      const compare = items.reduce(
        (sum, item) => sum + Math.max(Number(item.compare || 0), Number(item.price || 0)),
        0
      );

      /*
        FINAL MIXED-COMBO RULE:
        Any ready-made combo containing both Classic and Couture products
        uses the Couture 100ml quantity ladder for the total bottle count.
      */
      if (hasClassic && hasCouture) {
        const couture100Line = lineByKey('couture100');
        const mixedTier = tierFor(couture100Line, items.length);
        const fallbackPrice = items.reduce(
          (sum, item) => sum + Number(item.price || 0),
          0
        );

        return {
          price: mixedTier && mixedTier.fixedTotal > 0
            ? Number(mixedTier.fixedTotal)
            : fallbackPrice,
          compare
        };
      }

      const groups = new Map();
      items.forEach(item => {
        if (!groups.has(item.lineKey)) groups.set(item.lineKey, []);
        groups.get(item.lineKey).push(item);
      });

      let price = 0;
      groups.forEach((group, key) => {
        const matchingLine = lineByKey(key);
        const tier = tierFor(matchingLine, group.length);
        price += tier && tier.fixedTotal > 0
          ? Number(tier.fixedTotal)
          : group.reduce((sum, item) => sum + Number(item.price || 0), 0);
      });

      return {price, compare};
    }

    function autoComboCard(combo) {
      const {price, compare} = comboTotals(combo.items);
      const images = combo.items.map(item => item.image
        ? `<img src="${item.image}" alt="${item.title}" loading="lazy">`
        : `<span class="auto-combo-fallback" style="background:${item.colour}"></span>`).join('');

      const list = combo.items.map(item => `
        <div class="combo-li">
          <span class="d" style="background:${item.colour}"></span>
          <span>${item.title}</span>
          <span class="cl-s">${lineByKey(item.lineKey)?.label || item.lineKey}</span>
        </div>`).join('');

      const ids = combo.items.map(item => item.variantId).join(',');
      const lineKeys = combo.items.map(item => item.lineKey).join(',');
      const prices = combo.items.map(item => item.price).join(',');
      const compares = combo.items.map(item => item.compare).join(',');

      return `
        <article class="combo auto-combo" data-combo-card data-combo-type="${combo.type}"
          data-line-keys="${lineKeys}" data-prices="${prices}" data-compares="${compares}"
          data-combo-name="${combo.name.replace(/"/g, '&quot;')}"
          data-combo-titles="${combo.items.map(item=>item.title).join(', ').replace(/"/g, '&quot;')}">
          <div class="combo-scene">
            <div class="combo-tags">
              <span class="ctag type">${combo.type}</span>
              ${compare > price ? `<span class="ctag save">Save ${money(compare - price)}</span>` : ''}
            </div>
            <div class="combo-n2">${combo.items.length} bottles</div>
            <div class="auto-combo-images">${images}</div>
          </div>
          <div class="combo-b">
            <div class="combo-name">${combo.name}</div>
            <div class="combo-for">${combo.for}</div>
            <div class="combo-d">${combo.d}</div>
            <div class="combo-list">${list}</div>
            ${combo.how ? `<div class="combo-how"><b>How to layer:</b> ${combo.how}</div>` : ''}
            <div class="combo-price">
              <span class="a" data-combo-price>${money(price)}</span>
              ${compare > price ? `<span class="b">${money(compare)}</span>` : ''}
              ${compare > price ? `<span class="c">${Math.round((1 - price / compare) * 100)}% off</span>` : ''}
            </div>
            <div class="combo-cta">
              <button class="combo-add" type="button" data-combo-add data-variants="${ids}">Add combo</button>
              <button class="combo-buy" type="button" data-combo-buy data-variants="${ids}">Buy now</button>
            </div>
          </div>
        </article>`;
    }

    function premadePrice(card) {
      const keys = String(card.dataset.lineKeys || '')
        .split(',')
        .map(value => value.trim())
        .filter(Boolean);

      const prices = String(card.dataset.prices || '')
        .split(',')
        .map(Number);

      const hasClassic = keys.includes('classic100');
      const hasCouture = keys.some(key =>
        key === 'couture100' || key === 'couture25'
      );

      /*
        FINAL READY-MADE MIXED-COMBO RULE:
        Classic + Couture = Couture 100ml ladder
        based on the total number of bottles.
      */
      if (hasClassic && hasCouture) {
        const couture100Line = lineByKey('couture100');
        const mixedTier = tierFor(couture100Line, keys.length);
        const fallbackTotal = prices.reduce(
          (sum, value) => sum + Number(value || 0),
          0
        );

        return mixedTier && Number(mixedTier.fixedTotal) > 0
          ? Number(mixedTier.fixedTotal)
          : fallbackTotal;
      }

      const groups = new Map();

      keys.forEach((key, index) => {
        if (!groups.has(key)) groups.set(key, []);
        groups.get(key).push(prices[index] || 0);
      });

      let total = 0;

      groups.forEach((groupPrices, key) => {
        const matchingLine = lineByKey(key);
        const tier = tierFor(matchingLine, groupPrices.length);

        total += tier && Number(tier.fixedTotal) > 0
          ? Number(tier.fixedTotal)
          : groupPrices.reduce(
              (sum, value) => sum + Number(value || 0),
              0
            );
      });

      return total;
    }

    function renderPremade() {
      const container = $('combos');
      if (!container) return;

      let cards = [...container.querySelectorAll('[data-combo-card]')];
      if (!cards.length && data.autoCombos !== false) {
        const combos = AUTO_COMBOS.map(resolvedCombo).filter(combo => combo.items.length === combo.expected && combo.items.length >= 2);
        container.innerHTML = combos.map(autoComboCard).join('');
        cards = [...container.querySelectorAll('[data-combo-card]')];
      }

      const types = [...new Set(cards.map(card => card.dataset.comboType).filter(Boolean))];
      if ($('preCount')) $('preCount').textContent = `${cards.length} combos, composed by us`;

      if ($('cfilters')) {
        $('cfilters').innerHTML = ['All', ...types].map((type, index) => `
          <button class="pill ${index === 0 ? 'on' : ''}" type="button" data-type="${type}">${type}</button>
        `).join('');
        $('cfilters').querySelectorAll('[data-type]').forEach(button => {
          button.addEventListener('click', () => {
            const type = button.dataset.type;
            $('cfilters').querySelectorAll('.pill').forEach(item => item.classList.toggle('on', item === button));
            cards.forEach(card => { card.hidden = type !== 'All' && card.dataset.comboType !== type; });
          });
        });
      }

      cards.forEach(card => {
        const priceEl = card.querySelector('[data-combo-price]');
        if (priceEl) priceEl.textContent = money(premadePrice(card));
      });

      container.querySelectorAll('[data-combo-add], [data-combo-buy]').forEach(button => {
        if (button.dataset.bound) return;
        button.dataset.bound = '1';
        button.addEventListener('click', async () => {
          const ids = String(button.dataset.variants || '').split(',').map(v => v.trim()).filter(Boolean).map(Number);
          if (!ids.length) return;
          try {
            const card = button.closest('[data-combo-card]');
            const keys = String(card?.dataset.lineKeys || '').split(',').map(value => value.trim()).filter(Boolean);
            const titles = String(card?.dataset.comboTitles || '').split(',').map(value => value.trim()).filter(Boolean);
            await addPricedOrComponents(
              keys,
              ids,
              titles.length ? titles : ids.map(() => card?.dataset.comboName || 'Perfume'),
              card?.dataset.comboName || 'Ready-made combo',
              'combos_page_ready_made'
            );
            toast('Combo added to cart.');
            openThemeCart(button.hasAttribute('data-combo-buy'));
          } catch (error) {
            toast(error.message);
          }
        });
      });
    }

    async function submit(goCheckout) {
      if (!selected.length) { toast(data.labels.empty); return; }
      try {
        const regular = selected.filter(item => !item.isGift);
        const gifts = selected.filter(item => item.isGift);

        if (regular.length) {
          await addPricedOrComponents(
            [line?.key],
            regular.map(item => Number(item.variantId)),
            regular.map(item => item.title),
            line?.label || 'Build your own box',
            'combos_page_builder'
          );
        }

        if (gifts.length) {
          await addItems(gifts.map(item => ({id:Number(item.variantId), quantity:1})));
        }

        if (!bundleCheckout.enabled && line?.discountCode) {
          try {
            await fetch(`/discount/${encodeURIComponent(line.discountCode)}?redirect=/cart`, {credentials:'same-origin'});
          } catch (_) {}
        }
        toast('Box added to cart.');
        openThemeCart(goCheckout);
      } catch (error) {
        toast(error.message);
      }
    }

    function renderAll() {
      renderLines();
      renderLadder();
      renderProducts();
      renderSummary();
      renderBoxbar();
      renderExplainer();
    }

    document.querySelectorAll('#tabs [data-t]').forEach(button => {
      button.addEventListener('click', () => {
        document.querySelectorAll('#tabs .tab').forEach(item => item.classList.toggle('on', item === button));
        if ($('tabByo')) $('tabByo').style.display = button.dataset.t === 'byo' ? '' : 'none';
        if ($('tabPre')) $('tabPre').style.display = button.dataset.t === 'pre' ? '' : 'none';
        if (button.dataset.t === 'pre') renderPremade();
      });
    });

    $('bbGo')?.addEventListener('click', () => submit(true));
    $('bbClear')?.addEventListener('click', () => { selected.length = 0; renderAll(); });

    renderPremade();
    renderAll();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();